import { StringContext } from "../StringContext";
import { ScrollController } from "./ScrollController";

/**
 * Scroll controller that disables all user-initiated scrolling.
 * Prevents native scroll and wheel behavior, effectively locking the page.
 */
export class StringScrollDisable extends ScrollController {
  /** Unique name identifier for this scroll mode. */
  public readonly name: string = "disable";

  /**
   * Constructs the scroll disabling controller.
   * @param context The shared string system context.
   */

  private preventScroll = (e: Event) => {
    e.preventDefault();
  };

  private preventKeyScroll = (e: KeyboardEvent) => {
    const keysThatScroll = [
      "ArrowUp",
      "ArrowDown",
      "PageUp",
      "PageDown",
      " ",
      "Home",
      "End",
    ];
    if (keysThatScroll.includes(e.key)) {
      e.preventDefault();
    }
  };

  private onPreventScroll = this.preventScroll.bind(this);
  private onPreventKeyScroll = this.preventKeyScroll.bind(this);

  constructor(context: StringContext) {
    super(context);
  }

  enableScrollEvents() {
    window.addEventListener("touchmove", this.onPreventScroll, {
      passive: false,
    });
    window.addEventListener("keydown", this.onPreventKeyScroll);
  }

  disableScrollEvents() {
    window.removeEventListener("touchmove", this.onPreventScroll);
    window.removeEventListener("keydown", this.onPreventKeyScroll);
  }

  /**
   * Called on each animation frame.
   * Not used in this controller since scrolling is disabled.
   */
  public onFrame(): void {}

  /**
   * Prevents scroll via mouse wheel.
   * @param e Wheel event.
   */
  public onWheel(e: any): void {
    e.preventDefault();
  }

  /**
   * Prevents scroll via native scroll interaction (e.g. touch).
   * @param e Scroll event.
   */
  public onScroll(e: any): void {
    e.preventDefault();
  }
}
